import api from '@/api';

export const state = () => ({
  savedSearches: []
});

export const mutations = {
  SET_SAVED_SEARCHES(state, list) {
    state.savedSearches = list;
  },

  ADD_SAVED_SEARCH(state, search) {
    state.savedSearches.push(search);
  },

  REMOVE_SAVED_SEARCH(state, id) {
    state.savedSearches = state.savedSearches.filter((s) => s.id !== id);
  },

  UPDATE_SAVED_SEARCH(state, updated) {
    const index = state.savedSearches.findIndex((s) => s.id === updated.id);
    if (index !== -1) {
      state.savedSearches.splice(index, 1, updated);
    }
  },

  SET_SAVED_FILTER(state, { form, currentState }) {
    if (currentState !== undefined) {
      currentState.form = {
        ...currentState.form,
        ...form
      };
    }
  }
};

export const actions = {
  async getSavedSearches({ commit }) {
    try {
      const { data } = await api.getSavedUserFilters();
      commit('SET_SAVED_SEARCHES', data);
    } catch (error) {
      console.error('Помилка при завантаженні збережених фільтрів:', error);
    }
  },

  async addSavedSearch({ state, commit }, payload) {
    const label = payload.label.trim().toLowerCase();

    const duplicate = state.savedSearches.some(
      (s) => s.label.trim().toLowerCase() === label
    );

    if (duplicate) {
      this._vm.$notify({
        group: 'app',
        duration: 6000,
        type: 'error',
        text: 'Пошук з такою назвою вже існує'
      });

      return false;
    }

    try {
      const { data } = await api.createSavedUserFilter(payload);
      commit('ADD_SAVED_SEARCH', data);
    } catch (error) {
      console.error('Помилка при створенні збереженого фільтру:', error);
      return false;
    }
  },

  async removeSavedSearch({ commit }, id) {
    try {
      await api.deleteSavedUserFilter(id);
      commit('REMOVE_SAVED_SEARCH', id);
    } catch (error) {
      console.error('Помилка при видаленні збереженого фільтру:', error);
    }
  },

  async updateSavedSearch({ commit }, { id, data }) {
    try {
      const response = await api.updateSavedUserFilter(id, data);
      commit('UPDATE_SAVED_SEARCH', response.data);
    } catch (error) {
      console.error('Помилка при оновленні збереженого фільтру:', error);
    }
  },

  applySavedFilters({ rootState, commit }, savedSearch) {
    const filters = savedSearch.filters || {};

    Object.entries(filters).forEach(([key, data]) => {
      if (rootState[key] !== undefined && data.form) {
        commit('SET_SAVED_FILTER', {
          form: data.form,
          currentState: rootState[key]
        });
      }
    });

    if (savedSearch.business_type !== undefined) {
      commit('SET_BUSINESS_TYPE', savedSearch.business_type, {
        root: true
      });
    }

    if (savedSearch.type !== undefined) {
      commit('SET_BUILDING_TYPE', savedSearch.type, {
        root: true
      });
    }
  }
};
